// import React from "react";
// import {
//   Paper,
//   Typography,
//   Box,
//   List,
//   ListItem,
//   ListItemText,
//   Chip,
//   Divider,
// } from "@mui/material";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";

// export default function AIInsightsAnalytics({ insights = {} }) {
//   const topMatched = insights.topMatched || [];
//   const parsingStats = insights.parsingStats || {};
//   const diversity = insights.diversity || {};

//   const hasMatches = Array.isArray(topMatched) && topMatched.length > 0;

//   const formatDistribution = (obj) => {
//     if (!obj || typeof obj !== "object") return "-";
//     const entries = Object.entries(obj);
//     if (!entries.length) return "-";
//     return entries
//       .map(([key, value]) => `${key}: ${value}`)
//       .join(" • ");
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ mb: 1.5 }}>
//         <Typography
//           variant="overline"
//           sx={{
//             fontSize: 11,
//             letterSpacing: 0.8,
//             textTransform: "uppercase",
//             color: "text.secondary",
//           }}
//         >
//           AI Insights
//         </Typography>
//         <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
//           AI Insights & Analytics
//         </Typography>
//       </Box>

//       {/* Top-matched Candidates */}
//       <Box sx={{ mb: 2 }}>
//         <Box
//           sx={{
//             mb: 1,
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <TrendingUpIcon sx={{ fontSize: 18, color: "text.secondary" }} />
//           <Typography
//             variant="subtitle2"
//             sx={{ fontWeight: 600 }}
//           >
//             Top-matched Candidates
//           </Typography>
//         </Box>

//         <Box
//           sx={{
//             maxHeight: { xs: 160, sm: 180 },
//             overflowY: "auto",
//             borderRadius: 1,
//             border: hasMatches ? "1px solid rgba(229,231,235,0.7)" : "none",
//           }}
//         >
//           <List dense disablePadding>
//             {hasMatches ? (
//               topMatched.map((c) => (
//                 <ListItem
//                   key={c.id}
//                   sx={{
//                     px: 1.5,
//                     py: 0.75,
//                     "&:not(:last-of-type)": {
//                       borderBottom: "1px solid rgba(229,231,235,0.6)",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary={
//                       <Typography
//                         variant="body2"
//                         sx={{ fontWeight: 500 }}
//                         noWrap
//                       >
//                         {c.name}
//                       </Typography>
//                     }
//                     secondary={
//                       <Typography
//                         variant="caption"
//                         color="text.secondary"
//                         noWrap
//                       >
//                         {c.jobTitle}
//                       </Typography>
//                     }
//                   />
//                   <Chip
//                     label={`Score ${c.score}`}
//                     size="small"
//                     sx={{
//                       ml: 1,
//                       borderRadius: 999,
//                       height: 22,
//                       fontSize: 11,
//                       fontWeight: 600,
//                       bgcolor: "rgba(37,99,235,0.08)",
//                       color: "#1D4ED8",
//                     }}
//                   />
//                 </ListItem>
//               ))
//             ) : (
//               <ListItem sx={{ px: 1.5, py: 1 }}>
//                 <ListItemText
//                   primaryTypographyProps={{
//                     variant: "body2",
//                     color: "text.secondary",
//                   }}
//                   primary="No matches."
//                 />
//               </ListItem>
//             )}
//           </List>
//         </Box>
//       </Box>

//       <Divider sx={{ mb: 2 }} />

//       {/* Resume Parsing */}
//       <Box sx={{ mb: 2 }}>
//         <Box
//           sx={{
//             mb: 0.5,
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <DescriptionOutlinedIcon
//             sx={{ fontSize: 18, color: "text.secondary" }}
//           />
//           <Typography
//             variant="subtitle2"
//             sx={{ fontWeight: 600 }}
//           >
//             Resume Parsing
//           </Typography>
//         </Box>
//         <Typography
//           variant="body2"
//           sx={{ color: "text.secondary" }}
//         >
//           Parsed:{" "}
//           <Typography
//             component="span"
//             sx={{ fontWeight: 600, color: "text.primary" }}
//           >
//             {parsingStats.parsed || 0}
//           </Typography>
//           {" · "}
//           Errors:{" "}
//           <Typography
//             component="span"
//             sx={{ fontWeight: 600, color: "text.primary" }}
//           >
//             {parsingStats.errors || 0}
//           </Typography>
//         </Typography>
//       </Box>

//       {/* Diversity */}
//       <Box>
//         <Box
//           sx={{
//             mb: 0.5,
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <Groups2OutlinedIcon
//             sx={{ fontSize: 18, color: "text.secondary" }}
//           />
//           <Typography
//             variant="subtitle2"
//             sx={{ fontWeight: 600 }}
//           >
//             Diversity
//           </Typography>
//         </Box>

//         <Typography
//           variant="body2"
//           sx={{ color: "text.secondary", mb: 0.25 }}
//         >
//           <Typography
//             component="span"
//             sx={{ fontWeight: 500, color: "text.primary" }}
//           >
//             Gender:
//           </Typography>{" "}
//           {formatDistribution(diversity.gender)}
//         </Typography>

//         <Typography
//           variant="body2"
//           sx={{ color: "text.secondary" }}
//         >
//           <Typography
//             component="span"
//             sx={{ fontWeight: 500, color: "text.primary" }}
//           >
//             Location:
//           </Typography>{" "}
//           {formatDistribution(diversity.location)}
//         </Typography>
//       </Box>
//     </Paper>
//   );
// }


import React from "react";
import {
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Chip,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";

export default function AIInsightsAnalytics({ insights = {} }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const topMatched = insights.topMatched || [];
  const parsingStats = insights.parsingStats || {};
  const diversity = insights.diversity || {};

  const hasMatches = Array.isArray(topMatched) && topMatched.length > 0;

  const formatDistribution = (obj) => {
    if (!obj || typeof obj !== "object") return "-";
    const entries = Object.entries(obj);
    if (!entries.length) return "-";
    return entries.map(([key, value]) => `${key}: ${value}`).join(" • ");
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box sx={{ mb: 1.75 }}>
        <Typography
          sx={{
            fontSize: 11,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: muted,
            fontWeight: 500,
            fontFamily:
              '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
          }}
        >
          AI Insights
        </Typography>

        <Typography
          sx={{
            mt: 0.6,
            fontWeight: 800,
            fontSize: "1.35rem",
            lineHeight: 1.15,
            color: text,
            letterSpacing: "-0.02em",
          }}
        >
          AI Insights & Analytics
        </Typography>
      </Box>

      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            mb: 1,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <TrendingUpIcon sx={{ fontSize: 18, color: mid }} />
          <Typography
            sx={{
              fontSize: "0.95rem",
              fontWeight: 700,
              color: text,
            }}
          >
            Top-matched Candidates
          </Typography>
        </Box>

        <Box
          sx={{
            maxHeight: { xs: 160, sm: 180 },
            overflowY: "auto",
            borderRadius: "16px",
            border: hasMatches ? `1px solid ${border}` : "none",
          }}
        >
          <List dense disablePadding>
            {hasMatches ? (
              topMatched.map((c) => (
                <ListItem
                  key={c.id}
                  sx={{
                    px: 1.5,
                    py: 0.85,
                    "&:not(:last-of-type)": {
                      borderBottom: `1px solid ${border}`,
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: text,
                        }}
                        noWrap
                      >
                        {c.name}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        sx={{
                          mt: 0.3,
                          fontSize: "12px",
                          color: mid,
                        }}
                        noWrap
                      >
                        {c.jobTitle}
                      </Typography>
                    }
                  />
                  <Chip
                    label={`Score ${c.score}`}
                    size="small"
                    sx={{
                      ml: 1,
                      borderRadius: 999,
                      height: 24,
                      fontSize: 11,
                      fontWeight: 700,
                      bgcolor: dark
                        ? alpha(accent, 0.14)
                        : alpha(accent, 0.08),
                      color: accent,
                      border: `1px solid ${alpha(accent, 0.2)}`,
                    }}
                  />
                </ListItem>
              ))
            ) : (
              <ListItem sx={{ px: 1.5, py: 1 }}>
                <ListItemText
                  primaryTypographyProps={{
                    sx: { fontSize: "14px", color: mid },
                  }}
                  primary="No matches."
                />
              </ListItem>
            )}
          </List>
        </Box>
      </Box>

      <Divider sx={{ mb: 2, borderColor: border }} />

      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            mb: 0.6,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <DescriptionOutlinedIcon sx={{ fontSize: 18, color: mid }} />
          <Typography
            sx={{
              fontSize: "0.95rem",
              fontWeight: 700,
              color: text,
            }}
          >
            Resume Parsing
          </Typography>
        </Box>

        <Typography sx={{ fontSize: "14px", color: mid }}>
          Parsed:{" "}
          <Typography component="span" sx={{ fontWeight: 700, color: text }}>
            {parsingStats.parsed || 0}
          </Typography>
          {" · "}
          Errors:{" "}
          <Typography component="span" sx={{ fontWeight: 700, color: text }}>
            {parsingStats.errors || 0}
          </Typography>
        </Typography>
      </Box>

      <Box>
        <Box
          sx={{
            mb: 0.6,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Groups2OutlinedIcon sx={{ fontSize: 18, color: mid }} />
          <Typography
            sx={{
              fontSize: "0.95rem",
              fontWeight: 700,
              color: text,
            }}
          >
            Diversity
          </Typography>
        </Box>

        <Typography sx={{ fontSize: "14px", color: mid, mb: 0.45 }}>
          <Typography component="span" sx={{ fontWeight: 600, color: text }}>
            Gender:
          </Typography>{" "}
          {formatDistribution(diversity.gender)}
        </Typography>

        <Typography sx={{ fontSize: "14px", color: mid }}>
          <Typography component="span" sx={{ fontWeight: 600, color: text }}>
            Location:
          </Typography>{" "}
          {formatDistribution(diversity.location)}
        </Typography>
      </Box>
    </Paper>
  );
}